<template>
  <v-card elevation="0">
    <v-card-title class="pl-0">
      <StepHeader>
        {{ $t('register.profileInfo') }}
      </StepHeader>
      </v-card-title
    >
    <v-form @submit="proceedIfValid" onSubmit="return false;">
      <v-row align="center">
        <v-col cols="8">
          <UsernameTextField 
            v-model="username"
            :error-messages="usernameErrors"
            @valid="valid = $event"
          /> 
          </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-row justify="center">
            <v-avatar size="120" v-if="imageUrl != ''">
              <img :src="imageUrl" />
            </v-avatar>
            <v-icon size="120" v-else>mdi-account-circle</v-icon>
          </v-row>
          <v-row class="mt-7" justify="center">
            <MediaObjectUpload
              v-model="imageUrl"
              :requirements="{ minHeight: MIN_IMAGE_HEIGHT, minWidth: MIN_IMAGE_WIDTH }"
              :addText="$t('chapter.image.addImage')"
              :changeText="$t('chapter.image.changeImage')"
              @error="addImageErrorMessage"
              @loading="imageUploading = $event"
              @newId="newMediaId"
              :errorTooLargeMessage="
                $t('register.imageTooLarge', {
                  maxImageSize: MAX_IMAGE_UPLOAD_MEGABYTES,
                })
              "
              :maxSizeBytes="MAX_IMAGE_UPLOAD_BYTES"
              :formats="IMAGE_FORMATS"
            />
          </v-row>
          <v-row>
            <v-col class="text-center" cols="12">
              <span class="error-text">{{ imageErrorMessage }}</span>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row class="mt-9">
        <v-col>
          <v-btn tabindex="4" block type="submit" :disabled="!valid" color="primary">{{
            $t("register.next")
          }}</v-btn>
        </v-col>
      </v-row>
    </v-form>
    <v-snackbar v-model="imageUploading" right timeout="-1">
      <h3>{{ $t("forms.uploading") }}</h3>
      <v-progress-linear
        indeterminate
        class="mt-3"
        color="primaryAction darken-2"
      ></v-progress-linear>
    </v-snackbar>
  </v-card>
</template>
<script>
import { mapMutations, mapGetters } from "vuex";
import MediaObjectUpload from "@/components/MediaObjectUpload";
import StepHeader from "@/components/Reusable/StepHeader";
import UsernameTextField from "@/components/Reusable/UsernameTextField";
import {
  IMAGE_FORMATS,
  MAX_IMAGE_UPLOAD_BYTES,
  MAX_IMAGE_UPLOAD_MEGABYTES,
  MIN_IMAGE_HEIGHT,
  MIN_IMAGE_WIDTH,
  MAX_USERNAME_CHARS,
  MIN_USERNAME_CHARS,
} from "@/const";
export default {
  components: {
    MediaObjectUpload,
    StepHeader,
    UsernameTextField,
  },
  data() {
    return {
      username: "",
      queryUsername: "",
      queryAllowed: false,
      imageUrl: "",
      valid: false,
      temp: true,
      imageErrorMessage: null,
      imageUploading: false,
    };
  },
  beforeRouteEnter(to, from, next){
    next(vm => {
      if (vm) {
        vm.redirectToRegisterPageIfEmailOrPasswordMissing(vm);
      }
    })
  },
  beforeRouteUpdate(to, from, next) {
    if (this.redirectToRegisterPageIfEmailOrPasswordMissing(this)) {
      next(false);
    } else {
      next();
    }
  },
  methods: {
    ...mapMutations("auth/registration", ["setUsername", "setProfileImageId"]),
    newMediaId(id) {
      this.setProfileImageId(id);
    },
    redirectToRegisterPageIfEmailOrPasswordMissing(vm) {
      if (vm.email === null || vm.email == "" || vm.password === null || vm.password == "") {
        vm.$router.replace({ name: "register"});
        return true;
      }
      return false;
    },
    addImageErrorMessage(message) {
      this.imageErrorMessage = message;
    },
    proceedIfValid() {
      if (this.valid) {
        this.setUsername(this.username);
        this.$router.push("/auth/register/eula");
      }
    },
  },
  watch: {
    imageUrl() {
      this.imageErrorMessage = null;
    },
  },
  computed: {
    ...mapGetters("auth/registration", ["email", "password"]),
    MIN_USERNAME_CHARS() {
      return MIN_USERNAME_CHARS;
    },
    MAX_USERNAME_CHARS() {
      return MAX_USERNAME_CHARS;
    },
    MAX_IMAGE_UPLOAD_BYTES() {
      return MAX_IMAGE_UPLOAD_BYTES;
    },
    MAX_IMAGE_UPLOAD_MEGABYTES() {
      return MAX_IMAGE_UPLOAD_MEGABYTES;
    },
    MIN_IMAGE_WIDTH() {
      return MIN_IMAGE_WIDTH;
    },
    MIN_IMAGE_HEIGHT() {
      return MIN_IMAGE_HEIGHT;
    },
    IMAGE_FORMATS() {
      return IMAGE_FORMATS;
    },
    usernameErrors() {
      if (this.usernameExists) {
        return this.$t("register.usernameInUse");
      }
      return null;
    },
  },
};
</script>
<style  scoped>
::v-deep img {
  object-fit: cover;
}
.error-text {
  color: var(--v-error-base);
}
</style>